import type React from 'react';

/**
 * A left-click with no modifiers and no `target` is the only click an
 * artifact-aware link hijacks — ⌘/ctrl-click, middle-click and "open in new tab"
 * must still open the full page, which is why those links render a real anchor
 * with a real `href` either way.
 */
export const isPlainLeftClick = (
  event: React.MouseEvent<HTMLAnchorElement>,
  target: string | undefined
): boolean =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey &&
  (target === undefined || target === '' || target === '_self');
